import { ViewModel,View, Component } from "binder"
import  { GuageView } from "./guage-view"

export class GuageConfig{
    public 
}

export class GuageViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new GuageView();
    }
    public getTypeId(): string {
        return "VM-86AC4255-6939-4093-B76F-543CA0B571C6"
    }

    public set config(v: any) { this._config = v; } public get config(): any { return this._config;} private _config: any;
    public set value(v: number) { this._value = v; } public get value(): number { return this._value;} private _value: number;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
}
